import React from "react";
import TimelapseIcon from "@material-ui/icons/Timelapse";
// import DoneIcon from "@material-ui/icons/Done";
import LockIcon from "@material-ui/icons/Lock";
import PriorityHighIcon from "@material-ui/icons/PriorityHigh";

export const getStatusStyle = (status) => taskStatuses.find((x) => x.value === status).style;

export const taskStatuses = [
    {
        value: "todo",
        label: "To Do",
        style: {
            backgroundColor: "#dcdcdc",
            color: "#808080",
        },
        icon: <PriorityHighIcon />,
    },
    {
        value: "inprogress",
        label: "In Progress",
        style: {
            backgroundColor: "#eaecf7",
            color: "#3f51b5",
        },
        icon: <TimelapseIcon />,
    },
    // {
    //     value: "resolved",
    //     label: "Resolved",
    //     style: {
    //         backgroundColor: "#eaf7eb",
    //         color: "green",
    //     },
    //     icon: <DoneIcon />,
    // },
    {
        value: "closed",
        label: "Closed",
        style: {
            backgroundColor: "#eaf7eb",
            color: "green",
        },
        icon: <LockIcon />,
    },
];
